import { Match } from '../models';
import { MatchRepository } from '../repositories';

export class GetMatchesByTournamentUseCase {
  constructor(private matchRepository: MatchRepository) {}

  async execute(tournamentId: string): Promise<Match[]> {
    return await this.matchRepository.getByTournamentId(tournamentId);
  }
}
